import { render, staticRenderFns } from "./Currently.vue?vue&type=template&id=5175f51d&"
import script from "./Currently.vue?vue&type=script&lang=js&"
export * from "./Currently.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports